import * as classNames from 'classnames';
import { ILeadNote } from 'common/interfaces/provider';
import { ContentEditable } from 'components/content';
import { action, computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppStore } from 'stores/AllStores';

// Styles
const s = require('../LeadNotes.css');

//Props
export interface ILeadNoteContentProps {
  noteInfo: ILeadNote;
  store?: IAppStore;
}
// Component
@inject('store')
@observer
export class LeadNoteContent extends React.Component<
  ILeadNoteContentProps,
  {}
> {
  constructor(props: ILeadNoteContentProps) {
    super(props);
  }

  @computed private get isContentBeingEdited(): boolean {
    return this.props.store.lead.leadEditingNote.id === this.props.noteInfo.id;
  }

  @computed private get noteHtml(): string {
    const {
      lead: { openLeadNotes },
    } = this.props.store;
    let index = -1;
    openLeadNotes.some((note, noteIndex) => {
      if (note.id === this.props.noteInfo.id) {
        index = noteIndex;
        return true;
      }

      return false;
    });

    return index !== -1 ? openLeadNotes[index].comment : '';
  }

  public render() {
    return (
      <ContentEditable
        classNameForField={classNames(s.content, {
          [s.contentEditable]: this.isContentBeingEdited,
        })}
        autoFocus={true}
        contentEditable={this.isContentBeingEdited}
        onChange={this.handleLeadNoteChange}
        html={this.noteHtml}
      />
    );
  }

  @action private handleLeadNoteChange = (html: string, text: string) => {
    this.props.store.lead.leadEditingNote = {
      ...this.props.store.lead.leadEditingNote,
      html,
      text,
    };
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Notes/Note/LeadNoteContent.tsx